<template>
  <div class="main">
    <!--<input @click="openPicker()" type="text" v-model="time" placeholder="请选择时间">-->
    <span @click="openPicker()">{{ pick_time ? pick_time : '请选择时间' }}</span>
    <DatetimePicker
      ref="picker"
      v-model="pickerVisible"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      @confirm="handleConfirm"
    ></DatetimePicker>
  </div>
</template>

<script>
import { DatetimePicker } from 'mint-ui'

export default {
  props: ['time'],
  components: {
    DatetimePicker
  },
  mounted() {
    this.pick_time = this.time
  },
  data() {
    return {
      pickerVisible: '',
      startDate: new Date(),
      pick_time: ''
    }
  },
  methods: {
    openPicker() {
      this.$refs.picker.open()
    },
    // 格式化获取的时间
    formatDate(date) {
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + '-' + m + '-' + d
    },
    handleConfirm() {
      // 输出格式化后的时间
      this.pick_time = this.formatDate(this.$refs.picker.value)
      this.$emit('confirm', this.pick_time)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
span {
  border: 0;
  display: block;
  font-size: 0.4rem;
}
input::-webkit-input-placeholder {
  color: #4d4d4d;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #4d4d4d;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #4d4d4d;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #4d4d4d;
}
</style>
